// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2ey1H","file":"styles_file__1DMqF"};